<p-dialog
  [(visible)]="visible"
  [header]="'page.declarations.synthese.modal.synthese-saisies-revendications.title' | translate"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  [style]="{ width: numeroDossier() ? '30rem' : '90rem', height: 'auto' }"
  [contentStyle]="{ overflow: 'auto' }">

  @if (lotRevendications(); as lot) {
    @if (numeroDossier()) {
      <span>{{ 'page.declarations.synthese.modal.synthese-saisies-revendications.numeroDossier' | translate }}</span> : {{ numeroDossier() }}
    } @else {
      <!-- Affichage de l'entête du lot -->
      <div class="pt-4 pb-3 d-flex flex-wrap gap-3">
        <div class="">
          <p-floatlabel class="flex-grow-1">
            <input pInputText id="igp" type="text" [value]="lot.libelleCahier" readonly [disabled]="true" />
            <label for="igp">{{ 'page.declarations.synthese.modal.saisir-revendication.igp' | translate }}</label>
          </p-floatlabel>
        </div>
        <div class="">
          <p-floatlabel class="flex-grow-1">
            <p-datePicker
                inputId="date"
                [ngModel]="dateLot()"
                dateFormat="dd/mm/yy"
                [readonlyInput]="true"
                [disabled]="true"
                appendTo="body">
            </p-datePicker>
            <label for="date">{{ 'page.declarations.synthese.modal.synthese-saisies-revendications.date' | translate }}</label>
          </p-floatlabel>
        </div>
        <div class="">
          <p-floatlabel class="flex-grow-1">
            <input pInputText id="entreposage" type="text" [value]="lot.entreposage.adresse" readonly [disabled]="true" />
            <label for="entreposage">{{ 'page.declarations.synthese.modal.synthese-saisies-revendications.entreposage' | translate }}</label>
          </p-floatlabel>
        </div>
        <div class="">
          <p-floatlabel variant="on" class="flex-grow-1">
            <input pInputText id="campagne" type="text" [(ngModel)]="lot.campagne" name="campagne" />
            <label for="campagne">{{ 'page.declarations.synthese.modal.saisir-revendication.millesime' | translate }}</label>
          </p-floatlabel>
        </div>
      </div>
      <!-- Fin affichage de l'entête du lot -->

      <!-- Affichage des lots saisis -->
      <p-table [value]="lot.revendications" [scrollable]="true">
        <ng-template pTemplate="header">
          <tr>
            @for (col of columns; track col.field) {
              <th scope="col">{{ col.label | translate }}</th>
            }
            <th scope="col" style="width: 4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-saisie let-rowIndex="rowIndex">
          <tr>
            @for (col of columns; track col.field) {
              <td>
                @switch (col.field) {
                  @case ('cepages')             { {{ getCepages(saisie) }} }
                  @case ('destinations')        { {{ getDestinations(saisie) }} }
                  @case ('labels')              { {{ getEnvironnementLabels(saisie) }} }
                  @default                      { {{ saisie[col.field] }} }
                }
              </td>
            }
            <td>
                <p-button
                    icon="pi pi-pencil"
                    aria-label="Détail"
                    [pTooltip]="'Modifier le lot'"
                    tooltipPosition="left"
                    class="buttonIcon"
                    (click)="onEdit(rowIndex)"
                    (keydown.enter)="onEdit(rowIndex)"
                    [outlined]="true">
                </p-button>
                <p-button
                    icon="pi pi-trash"
                    aria-label="Détail"
                    [pTooltip]="'Supprimer le lot'"
                    tooltipPosition="left"
                    class="buttonIcon"
                    (click)="onDelete(rowIndex)"
                    (keydown.enter)="onDelete(rowIndex)"
                    [outlined]="true"
                    [hidden]="lot.revendications.length < 2">
                </p-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="columns.length + 1">{{ 'label.aucunResultat' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
      <!-- Fin affichage des lots saisis -->
    }
  }

  <ng-template pTemplate="footer">
      @if(numeroDossier()) {
          <p-button
              class="outline"
              label="{{ 'label.fermer' | translate }}"
              (click)="onClose(true)"
              (keydown.enter)="onClose(true)"
              icon="pi pi-check"
              type="button">
          </p-button>
      } @else {
          <p-button
              type="button"
              class="outline"
              [outlined]="true"
              label="{{ 'label.annuler' | translate }}"
              (click)="onClose()"
              (keydown.enter)="onClose()"
              icon="pi pi-times">
          </p-button>
          <p-button
              type="button"
              class="outline"
              label="{{ 'page.declarations.synthese.modal.synthese-saisies-revendications.ajouterLot' | translate }}"
              (click)="onAddSaisie()"
              (keydown.enter)="onAddSaisie()"
              icon="pi pi-plus">
          </p-button>
          <p-button
              type="button"
              class="outline"
              label="{{ 'label.valider' | translate }}"
              (click)="onSubmit()"
              (keydown.enter)="onSubmit()"
              icon="pi pi-check">
          </p-button>
      }
  </ng-template>
</p-dialog>
